let purchase = {
  title: "住宅代理",
  data_recharge: "流量充值",
  other_packages: "其他套餐",
  item: {
    item_1: "无限并发会话",
    item_2: "余额永久有效",
    item_3: "99.89%的成功率",
    item_4: "国家和城市级别定位"
  },
  ready: "准备好开始了吗？",
  contact_sales: "联系销售"
}
export default purchase


// WEBPACK FOOTER //
// ./src/assets/lang/zh/new_purchase/index.js